import { useMemo } from 'react'
import { Organization } from '../../../types'
import { useData } from '../contexts/DataContextProvider'
import styles from './Multiples.module.scss'
import MultiplesHeader from './MultiplesHeader'
import MultipleDotBars from './MultipleDotBars'
import { DEFAULT_LEGEND_ITEMS } from '../constants'

export default function FocusAreas() {
  const { data, definitions } = useData()

  const dataByFocusType = useMemo(() => {
    const focusTypes = new Map<string, { name: string; orgs: Organization[] }>()
    definitions.forEach(({ id = '', display_label: name }) => {
      if (id.includes('focus:')) {
        const type = id?.split(':')?.at(-1) || ''
        focusTypes.set(type, { name, orgs: [] })
      }
    })

    data.forEach((org) => {
      org?.focus?.forEach((type) => {
        if (focusTypes.has(type)) {
          focusTypes.get(type)?.orgs.push(org)
        }
      })
    })

    return Array.from(focusTypes.entries())
      .map(([id, { name, orgs }]) => ({
        name,
        orgs,
        value: `${((orgs.length / data.length) * 100).toFixed(1)}%`, // Calculate percentage of total organizations
      }))
      .sort(({ orgs: a }, { orgs: b }) => b.length - a.length)
  }, [data, definitions])

  return (
    <div className={`${styles.layout} ${styles.dark}`}>
      <MultiplesHeader
        title="Focus Areas"
        copy={[
          'Organizations working towards reparations for Black people may vary in focus area. We define a ‘focus area’ as the harm for which an organization seeks reparations.',

          'The terror of slavery didn’t end with its abolition. Through Jim Crow, redlining, lynching, police violence, and other state-authorized actions, Black people in America experienced continuous systemic harm- and still do today.',

          'The focus areas shown here, while not all-inclusive, represent a general summary of issues organizations target for reparations. You can see in the chart below the percentage of organizations that identify as working within these focus areas.',
        ]}
      />

      <MultipleDotBars
        maxNumberOfData={data.length}
        dataByMultiple={dataByFocusType}
        legendItems={DEFAULT_LEGEND_ITEMS}
      />
    </div>
  )
}
